<div class="contents">
  <app-back-button></app-back-button>
  <div class="header">
    <div class="instituicao-info">
      <div class="name-area">
        <div class="left-area">
          <span class="name">{{ bolsa?.nome }}</span>
          <div class="info">
            <span>Oferecida por <strong>{{ bolsa?.instituicaoGestora?.nome }}</strong></span>
            <span>•</span>
            <span>{{ bolsa?.vagas }} vagas </span>
            <span>•</span>
            <span><span class="status">{{ bolsa?.isActive ? 'Activa' : 'Inactiva' }}</span></span>
          </div>
        </div>
      </div>
      <div class="contact-info">
        <div class="phone">
          <div class="icon">
            <img src="icons/phone.svg" alt="Phone Icon" />
          </div>
          <span>{{ bolsa?.anoLectivoInicio }} à {{ bolsa?.anoLectivoFim }}</span>
        </div>
        <div class="email">
          <div class="icon">
            <img src="icons/award-01.svg" alt="Email Icon" />
          </div>
          <span>{{ bolsa?.tipoBolsa?.designacao }}</span>
        </div>
        <div class="email">
          <div class="icon">
            <img src="icons/graduation-grey.svg" alt="Email Icon" />
          </div>
          <span>{{ bolsa?.nivelAcademico }}</span>
        </div>
        <div class="email">
          <div class="icon">
            <img src="icons/coins-hand.svg" alt="Email Icon" />
          </div>
          <span>{{ bolsa?.tipoBolsaID === 1 ? 'Parcial' : 'Integral' }}</span>
        </div>
        <div class="country">
          <div class="icon">
            <img src="icons/globe.svg" alt="Country Icon" />
          </div>
          <span>{{ bolsa?.internacional ? 'Internacional' : 'Interna' }}</span>
        </div>
      </div>
    </div>
    <div class="indicator">
      <div class="avatars">
        <p-avatar-group>
          <p-avatar icon="pi pi-user" shape="circle" size="normal" />
          <p-avatar icon="pi pi-user" shape="circle" size="normal" />
          <p-avatar icon="pi pi-user" shape="circle" size="normal" />
          <p-avatar *ngIf="(bolsa?.bolseiros?.length || 0) > 3" [label]="'+' + ((bolsa?.bolseiros?.length || 0) - 3)" shape="circle" size="normal" />
        </p-avatar-group>
      </div>
      <div class="text">
        <span>{{ bolsa?.bolseiros?.length || 0 }} Estudantes</span>
      </div>
    </div>
  </div>
  <div class="actions">
    <p-button severity="secondary" [text]="true">
      <img src="icons/edit-05.svg" alt="Email Icon" />
      Editar
    </p-button>
    <p-button severity="primary" (onClick)="showDialog()">
      Vincular estudante
      <img src="icons/user-right-01.svg" alt="Email Icon" />
    </p-button>
    <p-button [label]="bolsa?.isActive ? 'Desativar' : 'Ativar'" icon="pi pi-info-circle" iconPos="right"
      severity="secondary" (click)="toggleBolsaStatus()" />
  </div>
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">
        <div class="tab-icon">
          <img src="icons/users-check.svg" alt="Email Icon" />
        </div>
        Estudantes vinculados
      </p-tab>
      <p-tab value="1">
        <div class="tab-icon">
          <img src="icons/building-05.svg" alt="Email Icon" />
        </div>
        Instituições
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-search-bar [showPrimaryBtn]="false"></app-search-bar>
        <app-listar-bolseiros [bolsaID]="bolsaID"></app-listar-bolseiros>
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-listar-instituicoes-ensino [bolsaID]="bolsaID"></app-listar-instituicoes-ensino>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <p-toast></p-toast>
</div>
